import { DocumentFields } from "../../validation/candidate-self-apply";
import { isNil } from "lodash";

export interface DocumentDefinition {
  isRequired: boolean;
  orgDocId: number;
}

export function checkAllRequiredDocumentsArePresent(
  documentDefinitions: DocumentDefinition[],
  documents: DocumentFields[],
): boolean {
  return documentDefinitions
    .filter((documentDefinition) => documentDefinition.isRequired)
    .every((documentDefinition) => {
      const document = documents.find(
        (document) =>
          document.orgcustomdocumentsId === documentDefinition.orgDocId,
      );

      if (document === undefined) {
        return false;
      }

      const userHasUploadedDocument = !isNil(document.file);
      const userHasPreviouslyUploadedDocument = !isNil(document.createdAt);

      return userHasUploadedDocument || userHasPreviouslyUploadedDocument;
    });
}
